'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
const DEFAULTS = {
  exportData: ImmutableMap(),
  id: 0,
  name: '',
  newMasterId: 0,
  page: null
};
export default class ModalOverrides extends Record(DEFAULTS) {
  static fromJS({
    exportData,
    id,
    name,
    newMasterId,
    page
  }) {
    return new ModalOverrides({
      exportData,
      id,
      name,
      newMasterId,
      page
    });
  }
}